import { FunctionComponent, useMemo } from "react";

import { CopywritingCampaign } from "@/pages/Private/pages/List/pages/ListEditCopywriting/ListEditCopywriting";

import { ListPerson } from "../../../schema/list";
import { ReachOutTarget } from "../reachOutTarget";
import { AlreadyConnectedNoticeView } from "./AlreadyConnectedNotice";
import { useAlreadyConnectedCheck } from "./useAlreadyConnectedCheck";

/**
 * The "already connected on LinkedIn" notice for one lead and a picked campaign (PREC-4426), for
 * assign flows outside the Reach out picker (Review to send's "Assign to campaign").
 */
export const LeadAlreadyConnectedNotice: FunctionComponent<{
	lead: ListPerson;
	campaign: CopywritingCampaign;
}> = ({ lead, campaign }) => {
	const target = useMemo<ReachOutTarget>(() => ({ kind: "lead", row: lead }), [lead]);

	return <AlreadyConnectedNoticeView check={useAlreadyConnectedCheck(target, campaign)} />;
};
